<template>
  <Modal
    v-model="_value"
    width="400"
    title="ZT设置IP"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="150">
      <FormItem prop="aisle" label="通道">
        <Select v-model="setDriverCardParams.aisle" style="width: 220px;" @on-change="selectAisle">
          <Option v-for="item in aisleOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="Type" label="地址类型">
        <Select v-model="setDriverCardParams.Type" style="width: 220px;">
          <Option v-for="item in TypeOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem v-if="setDriverCardParams.Type == 0" prop="CenterIP" label="设置IP">
        <Input v-model="setDriverCardParams.CenterIP" placeholder="设置IP" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem v-if="setDriverCardParams.aisle == 2" prop="Type" label="选择归属地">
        <Select v-model="DomainName" style="width: 220px;" @on-change="onChange">
          <Option v-for="item in DomainNameOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem v-if="setDriverCardParams.Type == 1" prop="DomainName" label="设置域名">
        <Input v-model="setDriverCardParams.DomainName" placeholder="设置域名" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem prop="ContrlPort" label="设置端口">
        <Input v-model="setDriverCardParams.ContrlPort" placeholder="设置端口" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem prop="ProcotolType" label="协议">
        <Select v-model="setDriverCardParams.ProcotolType" style="width: 220px;">
          <Option v-for="item in ProcotolTypeOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="Protocol808" label="协议版本">
        <Select v-model="setDriverCardParams.Protocol808" style="width: 220px;">
          <Option v-for="item in Protocol808Options" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import MaintainOrderAddMaintainDeviceRecordModal from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

export default {
  name: 'ztsetdrivercenternetworkmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        aisle: 1,
        Type: 0,
        CenterIP: null,
        DomainName: null,
        ContrlPort: null,
        ProcotolType: 11,
        Protocol808: 1,
      },
      aisleOptions: [
        {name: '主服', value: 1},
        {name: '备服', value: 2},
        {name: '扩一', value: 3},
        {name: '扩二', value: 4},
        {name: '扩三', value: 5},
      ],

      TypeOptions:[
        {name: 'IP', value: 0},
        {name: '域名', value: 1},
      ],

      ProcotolTypeOptions:[
        {name: '北斗协议', value: 0},
        {name: '808协议', value: 1},
        {name: '1078', value: 2},
        {name: '部标-苏标', value: 3},
        {name: '部标-陕标', value: 4},
        {name: '部标-疆标', value: 5},
        {name: '部标-黑标', value: 6},
        {name: '部标-浙标', value: 7},
        {name: '部标-冀标', value: 8},
        {name: '部标-川标', value: 9},
        {name: '部标-吉标', value: 10},
        {name: '部标-粤标', value: 11},
      ],

      Protocol808Options:[
        {name: '2011', value: 0},
        {name: '2019', value: 1},
      ],

      //域名选项
      DomainName:null,
      DomainNameOptions: [
        {name: '中山', value: '中山'},
        {name: '江门', value: '江门'},
        {name: '广州', value: '广州'},
        {name: '佛山', value: '佛山'},
      ],
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    onChange(){
      if (this.DomainName == '中山') {
        this.setDriverCardParams.DomainName = 'yt.dlysjg.td.gd.gov.cn'
        this.setDriverCardParams.ContrlPort = 30500
      }else if (this.DomainName == '江门') {
        this.setDriverCardParams.DomainName = 'yt.dlysjg.td.gd.gov.cn'
        this.setDriverCardParams.ContrlPort = 30700
      }else if (this.DomainName == '广州') {
        this.setDriverCardParams.DomainName = 'ya.dlysjg.td.gd.gov.cn'
        this.setDriverCardParams.ContrlPort = 30100
      }else if (this.DomainName == '佛山') {
        this.setDriverCardParams.DomainName = 'ye.dlysjg.td.gd.gov.cn'
        this.setDriverCardParams.ContrlPort = 30400
      }
    },
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.aisle = 1
        this.setDriverCardParams.Type = 0
        this.setDriverCardParams.CenterIP = null
        this.setDriverCardParams.DomainName = null
        this.setDriverCardParams.ContrlPort = null
        this.setDriverCardParams.ProcotolType = 11
        this.setDriverCardParams.Protocol808 = 1

      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.aisle = 1
      this.setDriverCardParams.Type = 0
      this.setDriverCardParams.CenterIP = null
      this.setDriverCardParams.DomainName = null
      this.setDriverCardParams.ContrlPort = null
      this.setDriverCardParams.ProcotolType = 11
      this.setDriverCardParams.Protocol808 = 1
  },
    selectAisle(){
      if (this.setDriverCardParams.aisle == 2) {
        this.setDriverCardParams.Type = 1
        // this.setDriverCardParams.DomainName = 'yt.dlysjg.td.gd.gov.cn'
        this.setDriverCardParams.ProcotolType = 11
        this.setDriverCardParams.Protocol808 = 1
      }else {
        this.setDriverCardParams.Type = 0
        this.setDriverCardParams.DomainName = null
      }
    },
    onSendDriverCardParams () {

      let content = "_CoMmAnD@XmL:<Param_CenterNetWork><MESSAGE_ID>1</MESSAGE_ID><MESSAGE_TYPE>2</MESSAGE_TYPE><id>"+this.setDriverCardParams.aisle+"</id><Enable>1</Enable><Type>"+this.setDriverCardParams.Type+"</Type>"
      if (this.setDriverCardParams.Type == 0) {
        content += "<CenterIP>" + this.setDriverCardParams.CenterIP + "</CenterIP>"
      }else {
        content += "<DomainName>"+this.setDriverCardParams.DomainName+"</DomainName>"
      }

      content += "<ContrlPort>"+this.setDriverCardParams.ContrlPort+"</ContrlPort><ProcotolType>"+this.setDriverCardParams.ProcotolType+"</ProcotolType><Protocol808>"+this.setDriverCardParams.Protocol808+"</Protocol808></Param_CenterNetWork>"

      console.log(content)
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: true }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
